import { type PropsWithChildren, useCallback, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { PropsWithClassName, PropsWithName } from "../types";
import { RawResizable } from "./RawResizable";

interface Props extends PropsWithClassName, PropsWithChildren, PropsWithName {
  maxWidth: number | null;
}
export function Resizable({ className, children, maxWidth, name }: Props) {
  const pixelWidth = useWatch({ name });
  const { register, setValue } = useFormContext();

  useEffect(() => {
    register(name);
  }, [register, name]);

  const handleWidthChange = useCallback(
    (width: number) => {
      setValue(name, width, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
    },
    [name, setValue],
  );

  return (
    <RawResizable
      className={className}
      maxWidth={maxWidth}
      initialWidth={pixelWidth ?? 0}
      onWidthChange={handleWidthChange}
    >
      {children}
    </RawResizable>
  );
}
